import distributeOrderService from "src/services/distributeOrderServices";

export const SEARCH_DISTRIBUTE_ORDER_REQUEST = "@distributeOrder/search-orders-request";
export const SEARCH_DISTRIBUTE_ORDER_SUCCESS = "@distributeOrder/search-orders-success";
export const SEARCH_DISTRIBUTE_ORDER_FAILURE = "@distributeOrder/search-orders-failure";

export const EDIT_STATE_WAYBILL = "@distributeOrder/edit-state-way-bill";
export const EDIT_STATE_WAYBILL_FAILURE = "@distributeOrder/edit-state-way-bill-failure";

export function searchDistributeOrder(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: SEARCH_DISTRIBUTE_ORDER_REQUEST});
      const response = await distributeOrderService.searchDistributeOrders(data);
      dispatch({
        type: SEARCH_DISTRIBUTE_ORDER_SUCCESS,
        payload: {
          response: response.data.data,
          total: response.data.total_items
        }
      });
    } catch (error) {
      dispatch({type: SEARCH_DISTRIBUTE_ORDER_FAILURE});
      throw error;
    }
  };
}

export function editStateWaybill(id, data) {
  return (dispatch) => {
    try {
      dispatch({
        type: EDIT_STATE_WAYBILL,
        payload: {
          id,
          data
        }
      });
    } catch (error) {
      dispatch({type: EDIT_STATE_WAYBILL_FAILURE});
      throw error;
    }
  };
}
